import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsDownloadAppraisalsAndReceiptsForJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      showJobScheduler: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  downloadAppraisalsAndReceiptsForJob() {
    console.log('receipts download here');
    return;
  }

  render() {
    return(
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          this.downloadAppraisalsAndReceiptsForJob();
        }}
        className="btn btn-lg btn-success">
        <i className="fa fa-download">
        </i> Download Appraisals and Receipts For Job
      </a>
    )
  }
}